<header class="header">
  <button
    (click)="scrollToMainContent()"
    class="header__skip-link"
    type="button"
  >
    Skip to content
  </button>

  <nav>
    <app-grid-container>
      <div class="header__inner">
        @if (assetsPath) {
          <a class="header__home-link" href="/">
            <app-image
              [fileAlt]="'Brand Logo'"
              [fileSrc]="`${assetsPath}/logo.svg`"
              class="header__logo"
            />
          </a>
        }

        <img
          [src]="`assets/powered-by-dng.svg`"
          alt="DNG Logo"
          class="header-logo-partner"
        />
      </div>
    </app-grid-container>
  </nav>
</header>
